import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { SessionService } from '../services/session.service';

export const headersInterceptor: HttpInterceptorFn = (req, next) => {
  const session = inject(SessionService);

  // ✅ No enviar Bearer en endpoints de auth
  const isAuthEndpoint =
    req.url.includes('/login') ||
    req.url.includes('/refresh') ||
    req.url.includes('/logout');

  if (isAuthEndpoint) return next(req);

  const token = session.getAccessToken();
  const authReq = token
    ? req.clone({ setHeaders: { Authorization: `Bearer ${token}` } })
    : req;

  return next(authReq);
};
